import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from './routes';
import { ToastContainer, toast } from 'react-toastify';
import { logger } from '@shared/utils/logger';
import { setGlobalApiErrorNotifier } from '@shared/services/api/baseApi';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    setGlobalApiErrorNotifier((message) => toast.error(message));
    return () => setGlobalApiErrorNotifier(null);
  }, []);
  logger.debug('📱 App.tsx: Rendering App component');
  logger.debug('🛣️ App.tsx: Routes:', routes);
  
  try {
    const element = useRoutes(routes);
    
    logger.debug('🎯 App.tsx: Route element:', element);
    
    if (!element) {
      logger.error('❌ No route matched!');
      return (
        <div style={{ padding: '20px', background: '#fdd', color: '#900' }}>
          <h1>No Route Matched</h1>
          <p>Current URL: {window.location.pathname}</p>
        </div>
      );
    }

    return (
      <>
        {element}
        <ToastContainer position="top-right" />
      </>
    );
  } catch (error) {
    logger.error('❌ App render error:', error);
    return (
      <div style={{ padding: '20px', background: '#fdd', color: '#900' }}>
        <h1>App Render Error</h1>
        <pre>{String(error)}</pre>
      </div>
    );
  }
}

export default App;

